import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getZonetree } from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsSlice';
import { CreateWorkShiftAccess } from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param id
 */
const AccessCardFunctionality = ({id, setModified}) => {
    let dispatch = useDispatch();
    const zoneData = useSelector(getZonetree);
    const { t } = useTranslation();

    const [fromValue, setfromValue] = useState(null);
    const [toValue, setToValue] = useState(null);
    const [allDays, setAllDays] = useState(false);
    const [allTime, setAllTime] = useState(false);
    const [checked, setChecked] = useState([]);
    const [dayArray, setDayArray] = useState([]);
    const [array, setArray] = useState([]);
    const [emptyFields, setEmptyFields] = useState(false);

    // Function to handle the checkbox selection
    const handleCheck = (event) => {
        let updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };
    // Function to handle the form submission aply selected
    const handleCLick = async () => {
        if (!fromValue || !toValue || checked.length === 0) {
            setEmptyFields(true)
            toast.warn(t('please_fill_all_fields'));
            return;
        }
        let updateArray = [...array];
        for (let i = 0; i < checked.length; i++) {
            for (let j = 0; j < dayArray.length; j++) {
                let x = {
                    zone: { id: checked[i] },
                    day: { id: dayArray[j] },
                    from: moment(fromValue).format('HH:mm:ss'),
                    to: moment(toValue).format('HH:mm:ss'),
                };
                updateArray.push(x);
            }
        }
        setArray(updateArray);
        // Create the custom schedule data to send in the dispatch
        let customSchedule = updateArray.map((item) => ({
            dayId: item?.day?.id,
            from: item?.from,
            to: item?.to,
            workShiftId: id,
            zoneId: item?.zone?.id.split(',', 1)[0],
        }));

        if (customSchedule.length > 0) {
            dispatch(CreateWorkShiftAccess(customSchedule)).then(() => {
                setChecked([]);
                setArray([]);
                setDayArray([]);
                setModified(true);
                setEmptyFields(false)
                setAllTime(false);
                setfromValue(null);
                setToValue(null);
            });
        }
    };

    return {
        zoneData,
        fromValue,
        setfromValue,
        toValue,
        setToValue,
        setAllDays,
        allTime,
        setAllTime,
        checked,
        setChecked,
        dayArray,
        setDayArray,
        handleCheck,
        handleCLick,
        emptyFields,
    };
};

export default AccessCardFunctionality;
